<template>
    <div>
        <div class="content-caption dashed">
            <span>基本信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group">
                <div class="form-label">
                    <label>买家名称</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.buyerRealComName || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>卖家名称</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.sellerRealComName || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>卖家标识</label>
                </div>
                <div class="form-value">
                    <span>{{ settleProof.buyerInnerSellerCode || '' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>结算描述</label>
                </div>
                <div class="form-value">
                    <textarea v-model="settleProof.memo" style="width: 320px;height: 90px"></textarea>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>验收单信息</span>
            <div class="fr" v-if="receiptList != null && receiptList.length > 0">
                <span>验收单数量：{{ receiptList.length || 0 }}</span>
                <span class="ml5">结算金额：{{ parseFloat(amount || 0).toFixed(2) }}元</span>
            </div>
        </div>
        <div class="table-layout">
            <div v-if="receiptList != null && receiptList.length > 0">
                <el-table ref="multipleTable" :data="receiptList" border tooltip-effect="dark" maxHeight="400" style="width: 100%">
                    <el-table-column align="center" prop="innerNo" label="验收单号" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="costCenterCode" label="成本中心" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="buyerBizUnitName" label="所属业务单元" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="createTime" label="创建时间" width="140"></el-table-column>
                    <el-table-column align="center" prop="contractNo" label="系统合同编号" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="ntxAmount" align="right" width="150" label="未税金额(元)">
                        <template slot-scope="rows">
                            <span>{{ (rows.row.ntxAmount || 0).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxAmount" align="right" width="150" label="税额(元)">
                        <template slot-scope="rows">
                            <span>{{ (rows.row.taxAmount || 0).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" align="right" width="150" label="税率(%)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wtxAmount" align="right" width="150" label="含税金额(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.wtxAmount != null">{{ rows.row.wtxAmount.toFixed(2) }}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="violateState" label="违约状态">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.violated && rows.row.violateState == 1">违约（未处理）</span>
                            <span class="font-green" v-else-if="rows.row.violated && rows.row.violateState == 0">违约（已处理）</span>
                            <span v-else-if="!rows.row.violated">正常</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'

    export default {
        name: 'swb-servc-work-settle-proof-save',
        desc: '工单验收单结算',
        props: {
            buyerRealComName: {
                type: String,
                default: null
            },
            sellerRealComName: {
                type: String,
                default: null
            },
            buyerInnerSellerCode: {
                type: String,
                default: null
            },
            receiptList: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                settleProof: {
                    memo: null
                },
                amount: 0,
                scopeEntity: {}
            }
        },
        created: function () {
            this.settleProof.buyerRealComName = this.buyerRealComName;
            this.settleProof.sellerRealComName = this.sellerRealComName;
            this.settleProof.buyerInnerSellerCode = this.buyerInnerSellerCode;
            let amount = 0;
            let receiptList = this.receiptList || [];
            for (let i = 0; i < receiptList.length; i++) {
                let receipt = receiptList[i];
                amount = amount + parseFloat(receipt.wtxAmount || 0);
            }
            this.amount = amount;
        },
        methods: {
            //
            getDlgResult: function () {
                let result = {};
                let settleProof = this.settleProof || {};
                let receiptList = this.receiptList || [];
                if (!Utils.isNoB(settleProof.memo) && settleProof.memo.length > 250) {
                    result.type = "warn";
                    result.message = '结算描述最大长度不可超过250！';
                    return result;
                }
                settleProof.receiptIds = Utils.merge([], receiptList.pluck("id"));
                //
                result.type = "info";
                result.data = Utils.merge({}, settleProof);
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/receipt/ServcWorkSettleProofSave.vue